export const DateDescending = () => {
  return (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 12.75H17.25L14.25 15.75L11.25 12.75H13.5V2.25H15V12.75ZM6 3.75C3.105 3.75 0.75 6.0975 0.75 9C0.75 11.9025 3.0975 14.25 6 14.25C8.895 14.25 11.25 11.9025 11.25 9C11.25 6.0975 8.9025 3.75 6 3.75ZM6 5.3625C8.0025 5.3625 9.6375 6.99 9.6375 9C9.6375 11.01 8.01 12.6375 6 12.6375C3.99 12.6375 2.3625 11.01 2.3625 9C2.3625 6.99 3.99 5.3625 6 5.3625ZM5.25 6.75V9.5175L7.6425 10.8975L8.205 9.9225L6.375 8.865V6.75" fill="black" />
  </svg>

  )
}